// Event, Dialog
import EventBus from "@/event/EventBus";
// Api
import api from '@/api/baseApi';
// Constant
import { SETTINGS_SNAPSHOT_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { SNAPSHOT_STATUS_INFO, SNAPSHOT_STATUS } from "@/constant/constant";
// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";

export default {

    extends: baseRentalService,
    components: {
        IconError: lazyLoadComponent({
            componentFactory: () => import("@/assets/svg/Error"),
            loading: SkeletonBox
        }),
    },
    data() {

        return {
            listSnapshot: [],
            displayMode: {
                LIST: 1,
                CREATE: 2,
                MODIFY: 3
            },
            currentDisplayMode: 1,
            conditionalCreate: {
                allowedCreated: false,
                messageInfo: '0',
                maxSnapshot: 1,
                typeUser: 1
            },
            conditionalCreateMsg: [
                '',
                'You can only create up to 1 snapshots for all image. You have reached the limit',
                'You can only create up to 3 snapshots for all image. You have reached the limit',
                'You can only create up to 1 snapshots for each image. You have reached the limit on this machine'
            ],
            newSnapshotItem: {
                name: '',
                description: ''
            },
            newSnapshotItemRules: {
                name: [
                    {
                        required: true,
                        message: "Name is required",
                        trigger: "blur"
                    },
                    { min: 3, max: 50, message: 'Length should be 3 to 50 characters', trigger: 'blur' }
                ],
                description: [
                    {
                        required: true,
                        message: "Description is required",
                        trigger: "blur"
                    },
                    { min: 3, max: 50, message: 'Length should be 3 to 250 characters', trigger: 'blur' }
                ],
            },
            intervalUpdate: null,
        };
    },

    computed: {
        snapshotStatusMap() {
            var obj = SNAPSHOT_STATUS_INFO.reduce(function (snapItem, cur, i) {
                snapItem[cur.id] = cur;
                return snapItem;
            }, {});
            return obj;
        },
        snapShotStatus() {
            return SNAPSHOT_STATUS;
        },
        canCreateModify() {
            return this.newSnapshotItem.name && this.newSnapshotItem.description;
        }
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetImage: function (newVal, oldVal) {
            this.getConditionalCreate();
            this.loadSnapshotList();
            this.autoUpdate();
        }
    },

    mounted() {
        this.getConditionalCreate();
        this.loadSnapshotList();
        this.autoUpdate();
    },
    destroyed() {
        if (this.intervalUpdate) clearInterval(this.intervalUpdate);
        this.$set(this, 'listSnapshot', []);
    },
    methods: {
        autoUpdate() {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            this.intervalUpdate = setInterval(() => {
                if (this.currentDisplayMode === this.displayMode.LIST && !this.isLoading) this.loadSnapshotList(true);
            }, 5000);
        },
        loadSnapshotList(isSlient = false) {
            if (!isSlient) this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                api.baseRequest(SETTINGS_SNAPSHOT_API.GET_SNAPSHOT_LIST, null, `/${this.targetImage.id}`)
                    .then((response) => {
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        if (!isSlient) {
                            this.$set(this, 'listSnapshot', response.data);
                            this.cancelAddModify();
                        }
                        else {
                            this.$set(this, 'listSnapshot', response.data);
                        }
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Load snapshot failed ...");
                    });
            }, this.smoothTimeOut);
        },
        getConditionalCreate() {
            api.baseRequest(SETTINGS_SNAPSHOT_API.CHECK_CONDITIONAL_CREATE, null, `/${this.targetImage.id}`)
                .then((response) => {
                    this.$set(this, 'conditionalCreate', response.data);
                })
                .catch(error => {

                });
        },
        openCreateForm() {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            this.newSnapshotItem = {
                name: '',
                description: ''
            };
            this.currentDisplayMode = this.displayMode.CREATE;
        },
        openModifyForm(targetItem) {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            this.newSnapshotItem = {
                id: targetItem.id,
                name: targetItem.name,
                description: targetItem.description
            };
            this.currentDisplayMode = this.displayMode.MODIFY;
        },
        cancelAddModify() {
            this.newSnapshotItem = {
                name: '',
                description: ''
            };
            this.currentDisplayMode = this.displayMode.LIST;
            this.autoUpdate();
        },
        commandOptions(params) {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            switch (params.commandName) {
                case 'MODIFY':
                    this.openModifyForm(params.data);
                    break;
                case 'REMOVE':
                    this.removeSnapshot(params.data);
                    break;
            }
        },
        removeSnapshot(targetItem) {
            this.showConfirm({ title: 'Confirm', message: 'This will permanently remove the snapshot. Continue?' }).then(() => {
                let data = {
                    id: targetItem.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                };
                api.baseRequest(SETTINGS_SNAPSHOT_API.REMOVE_SNAPSHOT, data)
                    .then((response) => {
                        this.loadSnapshotList();
                        this.notificationSuccess('Succeed !', 'The snapshot was deleted.');
                        this.autoUpdate();
                        this.getConditionalCreate();
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Load snapshot failed ...");
                        this.autoUpdate();
                        this.getConditionalCreate();
                    });
            }).catch(() => {

            });
        },
        createModifySnapshot() {
            this.$refs.snapshotForm.validate(valid => {
                if (valid) {
                    let isCreateNew = this.currentDisplayMode === this.displayMode.CREATE;
                    let message = isCreateNew ? 'This will create a new snapshot' : 'This will modified snapshot';
                    let messageSuccess = isCreateNew ? 'The snapshot was created !' : 'The snapshot was modified !';
                    this.showConfirm({ title: 'Confirm', message: `#${message}. Continue?` }).then(() => {
                        let apiSetting = isCreateNew ? SETTINGS_SNAPSHOT_API.CREATE_SNAPSHOT : SETTINGS_SNAPSHOT_API.UPDATE_SNAPSHOT;
                        let data = {};
                        if (isCreateNew) {
                            data = {
                                ...this.newSnapshotItem,
                                machineId: this.targetImage.id,
                                deviceInformation: JSON.stringify(this.getInformationClient())
                            };
                        }
                        else {
                            data = {
                                ...this.newSnapshotItem,
                                deviceInformation: JSON.stringify(this.getInformationClient())
                            };
                        }

                        api.baseRequest(apiSetting, data)
                            .then((response) => {
                                this.loadSnapshotList();
                                this.notificationSuccess('Succeed !', messageSuccess);
                                this.getConditionalCreate();
                            })
                            .catch(error => {
                                this.processCatchApiRequest(error, "Load snapshot failed ...");
                                this.getConditionalCreate();
                            });

                    }).catch(() => {
                        this.autoUpdate();
                        this.getConditionalCreate();
                    });
                } else {
                    return false;
                }
            });
        },
        restoreSnapshot(targetItem) {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            let msg = `Do you really want to restore this backup? Note that all image <strong>[${targetItem.vmMachineId}]</strong>-<strong>[${targetItem.imageName}]</strong> data will be overwritten. Continue?`;
            this.showConfirm({ title: 'Confirm', message: msg }).then(() => {
                let data = {
                    id: targetItem.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                };
                api.baseRequest(SETTINGS_SNAPSHOT_API.RESTORE_SNAPSHOT, data)
                    .then((response) => {
                        this.loadSnapshotList();
                        this.notificationSuccess('Succeed !', 'The snapshot restoring is inprogress.');
                        this.autoUpdate();
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Load snapshot failed ...");
                        this.autoUpdate();
                    });
            }).catch(() => {
                this.autoUpdate();
            });
        },
        // Close this pop-up
        closeThisPopup() {
            if (this.intervalUpdate) clearInterval(this.intervalUpdate);
            this.$set(this, 'listSnapshot', []);
            this.closePopup(POPUP_ID.SNAPSHOT_IMAGE);
        },
    },
}